// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error[data-v-3436bcac]{display:flex;flex-direction:column;font-weight:700;justify-content:space-around;text-align:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
